import api from '@/util/app-api'

export const state = {
  statuses: [],
  agentStatuses: [],
  allStatuses: [],
  fetched: false
}

export const mutations = {
  set(state, statuses) {
    state.statuses = [].concat(statuses)
    state.fetched = true
  },
}

export const actions = {
  async fetch({ state, commit }, options) {
    options = Object.assign({ force: false }, options)

    if (state.fetched && !options.force)
      return state.statuses
    
    return api.get('admin/LoanRequestStatus/List/', null)
    .then(data => {
      commit('set', data)
      return data
    })
  }
}

export const getters = {
  all: state => {
    return state.statuses
  },
  agentStatuses: state => {
    return state.statuses.filter(x=>x.statusGroup===1)
  },
  statuses: state => {
    return state.statuses.filter(x=>x.statusGroup===0)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
